import React, { useState, useEffect, useContext } from 'react';
import { db } from '../firebaseConfig.js'; // Importa tu configuración de Firebase
import {
  collection,
  query,
  where,
  getDocs,
  doc as firestoreDoc,
  getDoc,
  limit,
  startAfter,
  updateDoc,
} from 'firebase/firestore';
import { AuthContext } from '../context/AuthContext.js'; // Importa el AuthContext para obtener el usuario autenticado

const SolicitudPuntuacion = () => {
  const { currentUser } = useContext(AuthContext); // Obtén el usuario autenticado desde el contexto
  const [solicitudes, setSolicitudes] = useState([]);
  const [lastVisible, setLastVisible] = useState(null);
  const [totalSolicitudes, setTotalSolicitudes] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const ITEMS_PER_PAGE = 5; // Cantidad de elementos por página

  const fetchSolicitudes = async (direction = 'next') => {
    if (!currentUser) return; // Si no hay usuario autenticado, no hacemos nada

    setLoading(true);

    try {
      const solicitudesRef = collection(db, 'solicitudservicios');
      let q;

      if (direction === 'next') {
        q = query(
          solicitudesRef,
          where('uid', '==', currentUser.uid),
          where('estado', '==', 'finalizado'),
          limit(ITEMS_PER_PAGE),
          ...(lastVisible ? [startAfter(lastVisible)] : [])
        );
      } else {
        q = query(
          solicitudesRef,
          where('uid', '==', currentUser.uid),
          where('estado', '==', 'finalizado'),
          limit(ITEMS_PER_PAGE)
        );
      }

      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        const fetchedSolicitudes = await Promise.all(
          querySnapshot.docs.map(async (document) => {
            const data = document.data();
            let professionalName = 'Nombre no disponible';

            // Obtener el ID del usuario asignado
            if (data.asignado) {
              const userDocRef = firestoreDoc(db, 'users', data.asignado);
              const userDoc = await getDoc(userDocRef);

              if (userDoc.exists()) {
                professionalName = userDoc.data().fullName || 'Nombre no disponible';
              }
            }

            return {
              id: document.id,
              ...data,
              professionalName,
            };
          })
        );

        setSolicitudes(fetchedSolicitudes);
        setLastVisible(querySnapshot.docs[querySnapshot.docs.length - 1]);
      }
    } catch (error) {
      console.error('Error fetching solicitudes:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!currentUser) return; // No hacemos nada si no hay usuario autenticado

    const fetchTotalSolicitudes = async () => {
      const solicitudesRef = collection(db, 'solicitudservicios');
      const q = query(
        solicitudesRef,
        where('uid', '==', currentUser.uid),
        where('estado', '==', 'finalizado')
      );
      const querySnapshot = await getDocs(q);
      setTotalSolicitudes(querySnapshot.size);
    };

    fetchTotalSolicitudes();
    fetchSolicitudes();
  }, [currentUser]);

  const handleNextPage = () => {
    if (solicitudes.length === ITEMS_PER_PAGE) {
      setCurrentPage((prev) => prev + 1);
      fetchSolicitudes('next');
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
      fetchSolicitudes('prev');
    }
  };

  const handlePuntuar = async (solicitudId, profesionalId, puntuacion) => {
    try {
      // Verificar si ya se puntuó esta solicitud
      const solicitudRef = firestoreDoc(db, 'solicitudservicios', solicitudId);
      const solicitudDoc = await getDoc(solicitudRef);

      if (solicitudDoc.exists() && solicitudDoc.data().puntuacion) {
        alert('Este servicio ya ha sido puntuado.');
        return;
      }

      // Actualizar la solicitud con la puntuación
      await updateDoc(solicitudRef, { puntuacion });

      // Obtener el documento del profesional
      const profesionalRef = firestoreDoc(db, 'users', profesionalId);
      const profesionalDoc = await getDoc(profesionalRef);

      if (profesionalDoc.exists()) {
        const profesionalData = profesionalDoc.data();
        const { totalPuntuaciones = 0, promedioPuntuacion = 0 } = profesionalData;

        // Calcular nuevo promedio
        const nuevoTotal = totalPuntuaciones + 1;
        const nuevoPromedio =
          (promedioPuntuacion * totalPuntuaciones + puntuacion) / nuevoTotal;

        // Actualizar datos del profesional
        await updateDoc(profesionalRef, {
          totalPuntuaciones: nuevoTotal,
          promedioPuntuacion: nuevoPromedio,
        });
      }

      alert('Puntuación registrada exitosamente.');
      fetchSolicitudes(); // Actualizar solicitudes
    } catch (error) {
      console.error('Error al puntuar:', error);
      alert('Hubo un error al registrar la puntuación.');
    }
  };

  return (
    <div>
      <h2>Servicios Finalizados</h2>
      {loading ? (
        <p>Cargando...</p>
      ) : solicitudes.length > 0 ? (
        <div>
          <table className="table">
            <thead>
              <tr>
                <th>Servicio</th>
                <th>Nombre Profesional</th>
                <th>Puntuación</th>
              </tr>
            </thead>
            <tbody>
            {solicitudes.map((solicitud) => (
                <tr key={solicitud.id}>
                <td>{solicitud.category}</td>
                <td>{solicitud.professionalName}</td>
                <td>
                    {solicitud.puntuacion ? (
                    // Mostrar la puntuación si ya existe
                    <span>{solicitud.puntuacion} Estrellas</span>
                    ) : (
                    // Mostrar el selector si no se ha puntuado
                    <select
                        onChange={(e) =>
                        handlePuntuar(solicitud.id, solicitud.asignado, parseInt(e.target.value))
                        }
                        defaultValue="" className="form-control"
                    >
                        <option value="" disabled>
                        Seleccionar
                        </option>
                        {[1, 2, 3, 4, 5].map((score) => (
                        <option key={score} value={score}>
                            {score} Estrellas
                        </option>
                        ))}
                    </select>
                    )}
                </td>
                </tr>
            ))}
            </tbody>
          </table>
          <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'space-between' }}>
            <button onClick={handlePrevPage} disabled={currentPage === 1}>
              Anterior
            </button>
            <span>
              Página {currentPage} de {Math.ceil(totalSolicitudes / ITEMS_PER_PAGE)}
            </span>
            <button onClick={handleNextPage} disabled={solicitudes.length < ITEMS_PER_PAGE}>
              Siguiente
            </button>
          </div>
        </div>
      ) : (
        <p>No hay solicitudes finalizadas para mostrar.</p>
      )}
    </div>
  );
};

export default SolicitudPuntuacion;
